import styled from 'styled-components';
import { Text } from 'UI';

export const SContainer = styled.div`
  background-color: ${({ theme }) => theme.color.blue_dark_3};
  color: ${({ theme }) => theme.color.white};
  padding: 45px 0;
`;

export const SText = styled(Text)`
  :hover {
    color: ${({ theme }) => theme.color.white85};
  }
`;

export const LinksGrid = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, auto);
  gap: 80px;
`;
